import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Onboarding from "@/components/Onboarding";
import Dashboard from "@/components/Dashboard";
import { decodeData } from "@/lib/cycle";
import { I18nProvider } from "@/i18n";
import { initAnalytics, trackPageView } from "@/analytics";

const STORAGE_KEY = "cycleSync.data";

function loadInitial() {
  const params = new URLSearchParams(window.location.search);
  const shared = params.get("d");
  if (shared) {
    const decoded = decodeData(shared);
    if (decoded && decoded.lastPeriod) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(decoded));
      window.history.replaceState({}, "", window.location.pathname);
      return decoded;
    }
  }
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch (e) {
    console.error("Failed to read saved cycle data from localStorage:", e);
  }
  return null;
}

function App() {
  const [data, setData] = useState(loadInitial);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    initAnalytics();
    trackPageView({ title: "Cycle IQ" });
  }, []);

  useEffect(() => {
    if (data) localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }, [data]);

  const handleSubmit = (d) => {
    setData(d);
    setEditing(false);
  };

  const showOnboarding = !data || editing;

  return (
    <I18nProvider>
      <div className="App min-h-screen">
        {showOnboarding ? (
          <Onboarding initial={data} onSubmit={handleSubmit} />
        ) : (
          <Dashboard data={data} onEdit={() => setEditing(true)} />
        )}
        <Toaster position="top-center" richColors />
      </div>
    </I18nProvider>
  );
}

export default App;
